import type { TableFeature } from '@tanstack/react-table';

export const CellFallbackValue: TableFeature<unknown> = {
  createCell: (cell, column, row, table) => {
    cell.renderValue = () => {
      const content = cell.getValue();
      if (content || content === 0) return content;
      return table.options.renderFallbackValue;
    };
  },
};
